import { useEffect, useRef } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { useDocumentEditor } from "@/pages/dokumente/useDocumentEditor";

/**
 * Deep-Link-Route `/dokumente/:id` – öffnet den globalen Editor-Dialog
 * und navigiert nach Schließen zurück zur Dokumentenübersicht.
 */
export function DocumentEditorRoute() {
  const { id } = useParams();
  const navigate = useNavigate();
  const { open, close, isOpen } = useDocumentEditor();
  const openedRef = useRef(false);
  const sawOpenRef = useRef(false);

  const docId = Number(id);

  useEffect(() => {
    if (!Number.isFinite(docId) || docId <= 0) {
      navigate("/dokumente", { replace: true });
      return;
    }
    if (openedRef.current) return;
    openedRef.current = true;
    open({ docId });
  }, [docId, navigate, open]);

  useEffect(() => {
    if (isOpen) {
      sawOpenRef.current = true;
      return;
    }
    if (!sawOpenRef.current) return;
    navigate("/dokumente", { replace: true });
  }, [isOpen, navigate]);

  useEffect(() => {
    return () => {
      if (openedRef.current) close();
    };
  }, [close]);

  return null;
}
